/** Convierte un número de WhatsApp en una liga wa.me (o null si no hay número).
 *  Si pasas `text`, se añade como mensaje pre-rellenado (?text=...) para que al
 *  abrir el chat el remitente solo tenga que pulsar enviar. */
export function waLink(number, text) {
  const digits = (number || "").replace(/\D/g, "");
  if (!digits) return null;
  const base = `https://wa.me/${digits}`;
  if (!text) return base;
  return `${base}?text=${encodeURIComponent(text)}`;
}

/** Mensajes por defecto para los distintos contextos de la app. Mantenerlos aquí
 *  facilita ajustar el tono sin repetir lógica en cada componente. */
export function proToPatientMessage({ patientName = "", folio = "", proName = "" } = {}) {
  const greeting = patientName ? `Hola ${patientName.split(" ")[0]}` : "Hola";
  const folioTxt = folio ? ` (folio ${folio})` : "";
  const proTxt = proName ? `${proName} ` : "";
  return `${greeting}, te escribo de TransSalud. Soy ${proTxt}sobre tu solicitud de receta THAG${folioTxt}.`;
}

export function patientToProMessage({ patientName = "", folio = "" } = {}) {
  const name = patientName ? `Soy ${patientName.split(" ")[0]}` : "Soy paciente";
  const folioTxt = folio ? ` (folio ${folio})` : "";
  return `Hola, ${name}. Te escribo sobre mi solicitud de receta THAG${folioTxt} en TransSalud.`;
}
